/**
 * Text codes available to be used with useTranslation hook
 */
export const TextCodes = {
  Base: {
    Loading: 'BaseLocalization.Loading',
    Close: 'BaseLocalization.Close',
    Next: 'BaseLocalization.Next',
    Prev: 'BaseLocalization.Prev',
    Back: 'BaseLocalization.Back',
    Clear: 'BaseLocalization.Clear',
    Selected: 'BaseLocalization.Selected',
    ClearFilters: 'BaseLocalization.ClearFilters',
    Delete: 'BaseLocalization.Delete',
    NoFiles: 'BaseLocalization.NoFiles',
    ExportToExcel: 'BaseLocalization.ExportToExcel',
    ReadMore: 'BaseLocalization.ReadMore',
    UploadFileSuccess: 'BaseLocalization.UploadFileSuccess',
    Edit: 'BaseLocalization.Edit',
    Cancel: 'BaseLocalization.Cancel',
    Download: 'BaseLocalization.Download',
    SelectFilter: 'Select filter',
    Logout: 'BaseLocalization.Logout',
    NoResults: 'BaseLocalization.NoResults',
    Home: 'BaseLocalization.Home',
    GenericError: {
      PasswordRequired: 'UserCreateLocalizationService.PasswordRequired',
      FirstNameRequired: 'UserCreateLocalizationService.FirstNameRequired',
      LastNameRequired: 'UserCreateLocalizationService.LastNameRequired',
      PhoneNumberRequired: 'UserCreateLocalizationService.PhoneNumberRequired',
      InvalidEmailAddress: 'UserCreateLocalizationService.InvalidEmailAddress',
      ContactUs: 'BaseLocalization.ContactUs',
      ErrorLoadingData: 'BaseLocalization.ErrorLoadingData',
      UserNotAuthorized: 'BaseLocalization.UserNotAuthorized',
    },
    Print: 'BaseLocalization.Print',
  },
  Sorting: {
    Sorting: 'SortingLocalization.Sorting',
    NameAsc: 'SortingLocalization.NameAsc',
    NameDesc: 'SortingLocalization.NameDesc',
    PriceAsc: 'SortingLocalization.PriceAsc',
    PriceDesc: 'SortingLocalization.PriceDesc',
    DateAsc: 'SortingLocalization.DateAsc',
    DateDesc: 'SortingLocalization.DateDesc',
  },
  ProductRequest: {
    Status: {
      Open: 'ProductRequestLocalization.StatusOpen',
      Resolved: 'ProductRequestLocalization.StatusResolved',
    },
    Base: {
      Sorting: 'ProductRequestLocalization.Sorting',
      DateAsc: 'ProductRequestLocalization.DateAsc',
      DateDesc: 'ProductRequestLocalization.DateDesc',
      EmailAsc: 'ProductRequestLocalization.EmailAsc',
      EmailDesc: 'ProductRequestLocalization.EmailDesc',
      DealerNameAsc: 'ProductRequestLocalization.DealerNameAsc',
      DealerNameDesc: 'ProductRequestLocalization.DealerNameDesc',
      ContactFullNameAsc: 'ProductRequestLocalization.ContactFullNameAsc',
      ContactFullNameDesc: 'ProductRequestLocalization.ContactFullNameDesc',
      RequestDate: 'ProductRequestLocalization.RequestDate',
      DealerName: 'ProductRequestLocalization.DealerName',
      CreatedBy: 'ProductRequestLocalization.CreatedBy',
      Product: 'ProductRequestLocalization.Product',
      Status: 'ProductRequestLocalization.Status',
      Date: 'ProductRequestLocalization.Date',
      ClearFilters: 'ProductRequestLocalization.ClearFilters',
      Success: 'ProductRequestLocalization.Success',
      RequestDetails: 'ProductRequestLocalization.RequestDetails',
      Attachments: 'ProductRequestLocalization.Attachments',
      Submit: 'ProductRequestLocalization.Submit',
      UploadDocuments: 'ProductRequestLocalization.UploadDocuments',
      UploadDocumentsLimitError: 'ProductRequestLocalization.UploadDocumentsLimitError',
      Error: 'ProductRequestLocalization.Error',
    },
    Info: {
      ModalTitle: 'ProductInfoRequestFormLocalization.ModalTitle',
      Preamble: 'ProductInfoRequestFormLocalization.Preamble',
      Question: 'ProductInfoRequestFormLocalization.Question',
      Messages: 'ProductInfoRequestFormLocalization.Messages',
      WriteMessage: 'ProductInfoRequestFormLocalization.WriteMessage',
      Send: 'ProductInfoRequestFormLocalization.Send',
    },
    Order: {
      Confirmation: 'ProductOrderRequestFormLocalization.Confirmation',
      PrivacyPolicy: 'ProductOrderRequestFormLocalization.PrivacyPolicy',
      TermsAndConditions: 'ProductOrderRequestFormLocalization.TermsAndConditions',
      ModalTitle: 'ProductOrderRequestFormLocalization.ModalTitle',
      Preamble: 'ProductOrderRequestFormLocalization.Preamble',
      SpecialistAnswer: 'ProductOrderRequestFormLocalization.SpecialistAnswer',
      FindNearestDealer: 'ProductOrderRequestFormLocalization.FindNearestDealer',
      SelectDealer: 'ProductOrderRequestFormLocalization.SelectDealer',
      CustomerName: 'ProductOrderRequestFormLocalization.CustomerName',
      EnableLocationServices: 'ProductOrderRequestFormLocalization.EnableLocationServices',
      PhoneNumber: 'ProductOrderRequestFormLocalization.PhoneNumber',
      Email: 'ProductOrderRequestFormLocalization.Email',
      DeliveryNote: 'ProductOrderRequestFormLocalization.DeliveryNote',
      DeliveryNoteCue: 'ProductOrderRequestFormLocalization.DeliveryNoteCue',
      EnterZipCodeOrCity: 'ProductOrderRequestFormLocalization.EnterZipCodeOrCity',
      EnterDealerName: 'ProductOrderRequestFormLocalization.EnterDealerName',
      Address: 'ProductOrderRequestFormLocalization.Address',
      CustomerNo: 'ProductOrderRequestFormLocalization.CustomerNo',
      EstimatedDistance: 'ProductOrderRequestFormLocalization.EstimatedDistance',
    },
  },
  Search: {
    PaginationRowsPerPage: 'SearchLocalization.PaginationRowsPerPage',
    PaginationResults: 'SearchLocalization.PaginationResults',
    PaginationCurrentPage: 'SearchLocalization.PaginationCurrentPage',
    NavSearchPlaceholder: 'SearchLocalization.NavSearchPlaceholder',
    ResultsTitle: 'SearchLocalization.SearchResultsTitle',
    NoQueryTitle: 'SearchLocalization.NoQuery',
    ProductsTab: 'SearchLocalization.ProductsTab',
    ArticlesTab: 'SearchLocalization.ArticlesTab',
    DocumentTab: 'SearchLocalization.DocumentsTab',
    AccessoriesTab: 'SearchLocalization.AccessoriesTab',
    NoResultsInSection: 'SearchLocalization.NoResultsInSection',
    GoToFullSearch: 'SearchLocalization.GoToFullSearch',
    AllCategories: 'SearchLocalization.AllCategories',
    SelectedSection: 'SearchLocalization.SelectedSection',
    SelectedCategory: 'SearchLocalization.SelectedCategory',
    Category: 'SearchLocalization.Category',
    QuickAdd: 'SearchLocalization.QuickAdd',
    Accessories: 'SearchLocalization.Accessories',
    ShowAllCategories: 'SearchLocalization.ShowAllCategories',
    ShowSelectedCategory: 'SearchLocalization.ShowSelectedCategory',
  },
  Product: {
    Wishlist: {
      Product: 'WishlistLocalization.Product',
      AddToWishlist: 'WishlistLocalization.AddToWishlist',
      AddToCart: 'WishlistLocalization.AddToCart',
      Price: 'WishlistLocalization.Price',
      RemoveFromFavorites: 'WishlistLocalization.RemoveFromFavorites',
      Empty: 'WishlistLocalization.Empty',
      AddAllToCart: 'WishlistLocalization.AddAllToCart',
      Error: 'WishlistLocalization.Error',
      Success: 'WishlistLocalization.Success',
      Removed: 'WishlistLocalization.Removed',
    },
    Money: {
      IncludeTaxes: 'MoneyLocalization.IncludeTaxes',
      ExcludeTaxes: 'MoneyLocalization.ExcludeTaxes',
    },
    Search: {
      NoResults: 'ProductSearchLocalization.NoResults',
      LoadMore: 'ProductSearchLocalization.LoadMore',
    },
    Cart: {
      Expired: 'ProductCartLocalization.Expired',
      AddToCart: 'ProductCartLocalization.AddToCart',
      ProductAdded: 'ProductCartLocalization.ProductAdded',
      ProductRemoved: 'ProductCartLocalization.ProductRemoved',
      ProductQuantityChanged: 'ProductCartLocalization.ProductQuantityChanged',
      ProductNoteChanged: 'ProductCartLocalization.ProductNoteChanged',
      ProductCartError: 'ProductCartLocalization.ProductCartError',
      CartSavedAsDraft: 'ProductCartLocalization.CartSavedAsDraft',
      Summary: 'ProductCartLocalization.Summary',
      Products: 'ProductCartLocalization.Products',
      Total: 'ProductCartLocalization.Total',
      Price: 'ProductCartLocalization.Price',
      Quantity: 'ProductCartLocalization.Quantity',
      Subtotal: 'ProductCartLocalization.Subtotal',
      Delivery: 'ProductCartLocalization.Delivery',
      Tax: 'ProductCartLocalization.Tax',
      SearchLabel: 'ProductCartLocalization.SearchLabel',
      SearchPlaceholder: 'ProductCartLocalization.SearchPlaceholder',
      Remove: 'ProductCartLocalization.Remove',
      Comment: 'ProductCartLocalization.Comment',
      Proceed: 'ProductCartLocalization.Proceed',
      SaveDraft: 'ProductCartLocalization.SaveDraft',
      NumberInCart: 'ProductCartLocalization.NumberInCart',
      Empty: 'ProductCartLocalization.Empty',
      ProductCount: 'ProductCartLocalization.ProductCount',
      DeliveryInfo: 'ProductCartLocalization.DeliveryInfo',
      ProductItemCartNote: 'ProductCartLocalization.ProductItemCartNote',
      PriceNotAvailable: 'ProductCartLocalization.PriceNotAvailable',
      SuggestedPrice: 'ProductCartLocalization.SuggestedPrice',
      YourPrice: 'ProductCartLocalization.YourPrice',
      ClearCart: 'ProductCartLocalization.ClearCart',
      CartCleared: 'ProductCartLocalization.CartCleared',
    },
    Checkout: {
      DeliveryInfo: 'ProductCheckoutLocalization.DeliveryInfo',
      DeliveryOption: 'ProductCheckoutLocalization.DeliveryOption',
      InvoiceInformation: 'ProductCheckoutLocalization.InvoiceInformation',
      OrderSummary: 'ProductCheckoutLocalization.OrderSummary',
      Checkout: 'ProductCheckoutLocalization.Checkout',
      OrderConfirmation: 'ProductCheckoutLocalization.OrderConfirmation',
      PlaceOrder: 'ProductCheckoutLocalization.PlaceOrder',
      OrderPlaced: 'ProductCheckoutLocalization.OrderPlaced',
      OrderShippingSoon: 'ProductCheckoutLocalization.OrderShippingSoon',
      OrderShippingSentEmail: 'ProductCheckoutLocalization.OrderShippingSentEmail',
      OrderShippingInfo: 'ProductCheckoutLocalization.OrderShippingInfo',
      OrderShippingInfo2: 'ProductCheckoutLocalization.OrderShippingInfo2',
      DeliveryAddress: 'ProductCheckoutLocalization.DeliveryAddress',
      PreferredDeliveryWeekStart: 'ProductCheckoutLocalization.PreferredDeliveryWeekStart',
      PreferredDeliveryWeekEnd: 'ProductCheckoutLocalization.PreferredDeliveryWeekEnd',
      PaymentReminderDate: 'ProductCheckoutLocalization.PaymentReminderDate',
      DeliveryNote: 'ProductCheckoutLocalization.DeliveryNote',
      PreferredDeliveryWeekError: 'ProductCheckoutLocalization.PreferredDeliveryWeekError',
      OrderReference: 'ProductCheckoutLocalization.OrderReference',
      OrderError: 'ProductCheckoutLocalization.OrderError',
      AddressNotExistError: 'ProductCheckoutLocalization.AddressNotExistError',
      RequestDeliveryDate: 'ProductCheckoutLocalization.RequestDeliveryDate',
      CharacterLimitError: 'ProductCheckoutLocalization.CharacterLimitError',
    },
    Details: {
      Description: 'ProductLocalization.Description',
      Specifications: 'ProductLocalization.Specifications',
      Documents: 'ProductLocalization.Documents',
      Options: 'ProductLocalization.Options',
      Accessories: 'ProductLocalization.Accessories',
      SimilarProducts: 'ProductLocalization.SimilarProducts',
      RelatedMaterials: 'ProductLocalization.RelatedMaterials',
      LocateDealer: 'ProductLocalization.LocateDealer',
      SelectVariant: 'ProductLocalization.SelectVariant',
      UpsaleProducts: 'ProductLocalization.UpsaleProducts',
      CurrentImageCaption: 'ProductLocalization.CurrentImageCaption',
      JumpToSection: 'ProductLocalization.JumpToSection',
      RequestInformation: 'ProductLocalization.RequestInformation',
      InStock: 'ProductLocalization.InStock',
      NotInStock: 'ProductLocalization.NotInStock',
      ProductNumber: 'ProductLocalization.ProductNumber',
      AddToWishlist: 'ProductLocalization.AddToWishlist',
      OrderProduct: 'ProductLocalization.OrderProduct',
      RequestOrder: 'ProductLocalization.RequestOrder',
      IncludeBatteryAndCharger: 'ProductLocalization.IncludeBatteryAndCharger',
      IncludeChargerOnly: 'ProductLocalization.IncludeChargerOnly',
      IncludeBatteryOnly: 'ProductLocalization.IncludeBatteryOnly',
      IncludeBatteriesAndCharger: 'ProductLocalization.IncludeBatteriesAndCharger',
      IncludeBatteryAndChargers: 'ProductLocalization.IncludeBatteryAndChargers',
      IncludeBatteriesAndChargers: 'ProductLocalization.IncludeBatteriesAndChargers',
      PackageDetails: 'ProductLocalization.PackageDetails',
      NumberOfBatteries: 'ProductLocalization.NumberOfBatteries',
      NumberOfChargers: 'ProductLocalization.NumberOfChargers',
      Battery: 'ProductLocalization.Battery',
      Charger: 'ProductLocalization.Charger',
      PackageDeal: 'ProductLocalization.PackageDeal',
      ToBeOrdered: 'ProductLocalization.ToBeOrdered',
      BelowThresholdStock: 'ProductLocalization.BelowThresholdStock',
      AboveThresholdStock: 'ProductLocalization.AboveThresholdStock',
      IncludeBatteriesOnly: 'ProductLocalization.IncludeBatteriesOnly',
      IncludeChargersOnly: 'ProductLocalization.IncludeChargersOnly',
      Campaign: 'ProductLocalization.Campaign',
    },
  },
  Customer: {
    Block: {
      SearchDealerPlaceholder: 'CustomerBlockLocalization.SearchDealerPlaceholder',
      CustomerNo: 'CustomerBlockLocalization.CustomerNo',
      CustomerName: 'CustomerBlockLocalization.CustomerName',
      Users: 'CustomerBlockLocalization.Users',
      LastOrderDate: 'CustomerBlockLocalization.LastOrderDate',
      LastLoginDate: 'CustomerBlockLocalization.LastLoginDate',
      Search: 'CustomerBlockLocalization.SearchLabel',
      Clear: 'CustomerBlockLocalization.Clear',
    },
  },
  Dealer: {
    Details: {
      AddContact: 'DealerDetailsLocalization.AddContact',
      DealerDetails: 'DealerDetailsLocalization.DealerDetails',
      Users: 'DealerDetailsLocalization.Users',
      Name: 'DealerDetailsLocalization.Name',
      Email: 'DealerDetailsLocalization.Email',
      LastLogin: 'DealerDetailsLocalization.LastLogin',
      PhoneNumber: 'DealerDetailsLocalization.PhoneNumber',
      ShopInformation: 'DealerDetailsLocalization.ShopInformation',
      ShopName: 'DealerDetailsLocalization.ShopName',
      WorkingHours: 'DealerDetailsLocalization.WorkingHours',
      Services: 'DealerDetailsLocalization.Services',
      Brands: 'DealerDetailsLocalization.Brands',
      Contacts: 'DealerDetailsLocalization.Contacts',
      Save: 'DealerDetailsLocalization.Save',
      CreateUser: 'DealerDetailsLocalization.CreateUser',
      DeleteUser: 'DealerDetailsLocalization.DeleteUser',
      DeleteUserConfirmation: 'DealerDetailsLocalization.DeleteUserConfirmation',
      FirstName: 'DealerDetailsLocalization.FirstName',
      LastName: 'DealerDetailsLocalization.LastName',
      GoogleMapsCoordinatesProblem: 'DealerDetailsLocalization.GoogleMapsCoordinatesProblem',
      UpdateSuccess: 'DealerDetailsLocalization.UpdateSuccess',
      CreateUserSuccess: 'DealerDetailsLocalization.CreateUserSuccess',
      ContactEmail: 'DealerDetailsLocalization.ContactEmail',
      Website: 'DealerDetailsLocalization.Website',
      MobilePhoneNumber: 'DealerDetailsLocalization.MobilePhoneNumber',
      UpdateError: 'DealerDetailsLocalization.UpdateError',
      Address: 'DealerDetailsLocalization.Address',
      City: 'DealerDetailsLocalization.City',
      PostalCode: 'DealerDetailsLocalization.PostalCode',
      ShopDetails: 'DealerDetailsLocalization.ShopDetails',
      MissingEmailAddress: 'UserDeleteLocalizationService.MissingEmailAddress',
    },
    Find: {
      Dealer: 'FindDealerLocalization.Dealer',
      Places: 'FindDealerLocalization.Places',
      City: 'FindDealerLocalization.City',
      FindDealer: 'FindDealerLocalization.FindDealer',
      Filter: 'FindDealerLocalization.Filter',
      Search: 'FindDealerLocalization.Search',
      AllDealers: 'FindDealerLocalization.AllDealers',
      Address: 'FindDealerLocalization.Address',
      Services: 'FindDealerLocalization.Services',
      WorkingHours: 'FindDealerLocalization.WorkingHours',
      Phone: 'FindDealerLocalization.Phone',
      ContactEmail: 'FindDealerLocalization.ContactEmail',
      InvoiceEmail: 'FindDealerLocalization.InvoiceEmail',
      SalePhone: 'FindDealerLocalization.SalePhone',
      ServicePhone: 'FindDealerLocalization.ServicePhone',
      Brands: 'FindDealerLocalization.Brands',
      ApplyFilter: 'FindDealerLocalization.ApplyFilter',
      NoFilters: 'FindDealerLocalization.NoFilters',
      OtherPhone: 'FindDealerLocalization.OtherPhone',
      NoDealersFound: 'FindDealerLocalization.NoDealersFound',
      NoResults: 'FindDealerLocalization.NoResults',
      DealerDetails: 'FindDealerLocalization.DealerDetails',
      ShowOnMap: 'FindDealerLocalization.ShowOnMap',
      Loading: 'FindDealerLocalization.Loading',
      PermissionLocationDenied: 'FindDealerLocalization.PermissionLocationDenied',
      DealersNearby: 'FindDealerLocalization.DealersNearby',
      ClearFilter: 'FindDealerLocalization.ClearFilter',
    },
  },
  Contact: {
    InvoiceEmail: 'ContactLocalization.InvoiceEmail',
    MobilePhoneNumber: 'ContactLocalization.MobilePhoneNumber',
    DaytimePhoneNumber: 'ContactLocalization.DaytimePhoneNumber',
    GeneralPhoneNumber: 'ContactLocalization.GeneralPhoneNumber',
    Email: 'ContactLocalization.Email',
    ContactEmail: 'ContactLocalization.ContactEmail',
    EmailFromContacts: 'ContactLocalization.EmailFromContacts',
    EveningPhoneNumber: 'ContactLocalization.EveningPhoneNumber',
    SalePhoneNumber: 'ContactLocalization.SalePhoneNumber',
    ServicePhoneNumber: 'ContactLocalization.ServicePhoneNumber',
    WorkShopPhoneNumber: 'ContactLocalization.WorkShopPhoneNumber',
    OtherPhoneNumber: 'ContactLocalization.OtherPhoneNumber',
  },
  Order: {
    Block: {
      SearchPlaceholder: 'OrderBlockLocalization.SearchPlaceholder',
      CustomerNo: 'OrderBlockLocalization.CustomerNo',
      Clear: 'OrderBlockLocalization.Clear',
      Comment: 'OrderBlockLocalization.Comment',
      CreatedBy: 'OrderBlockLocalization.CreatedBy',
      CreatedOn: 'OrderBlockLocalization.CreatedOn',
      CustomerName: 'OrderBlockLocalization.CustomerName',
      DealerOrderId: 'OrderBlockLocalization.DealerOrderId',
      DeliveryDate: 'OrderBlockLocalization.DeliveryDate',
      DeliveryTo: 'OrderBlockLocalization.DeliveryTo',
      History: 'OrderBlockLocalization.History',
      OrderContent: 'OrderBlockLocalization.OrderContent',
      OrderStatus: 'OrderBlockLocalization.OrderStatus',
      OrderType: 'OrderBlockLocalization.OrderType',
      OrderNumber: 'OrderBlockLocalization.OrderNumber',
      Search: 'OrderBlockLocalization.SearchLabel',
      TraceId: 'OrderBlockLocalization.TraceId',
      TrackingNumber: 'OrderBlockLocalization.TrackingNumber',
      Orders: 'OrderBlockLocalization.Orders',
    },
    Details: {
      OrderDetailsHeader: 'OrderDetailsLocalization.OrderDetailsHeader',
      OrderInfoHeader: 'OrderDetailsLocalization.OrderInfoHeader',
      OrderCommentsHeader: 'OrderDetailsLocalization.OrderCommentsHeader',
      OrderDeliveryHeader: 'OrderDetailsLocalization.OrderDeliveryHeader',
      OrderSummaryHeader: 'OrderDetailsLocalization.OrderSummaryHeader',
      Created: 'OrderDetailsLocalization.Created',
      CustomerEmail: 'OrderDetailsLocalization.CustomerEmail',
      CustomerName: 'OrderDetailsLocalization.CustomerName',
      DeliveryAddress: 'OrderDetailsLocalization.DeliveryAddress',
      DeliveryTerms: 'OrderDetailsLocalization.DeliveryTerms',
      ExpectedDeliveryTime: 'OrderDetailsLocalization.ExpectedDeliveryTime',
      History: 'OrderDetailsLocalization.History',
      ProductColumn: 'OrderDetailsLocalization.ProductColumn',
      QuantityColumn: 'OrderDetailsLocalization.QuantityColumn',
      SerialNumberColumn: 'OrderDetailsLocalization.SerialNumberColumn',
      TrackOrder: 'OrderDetailsLocalization.TrackOrder',
      TrackingNumber: 'OrderDetailsLocalization.TrackingNumber',
      UnitPriceColumn: 'OrderDetailsLocalization.UnitPriceColumn',
      TotalColumn: 'OrderDetailsLocalization.TotalColumn',
      DiscountColumn: 'OrderDetailsLocalization.DiscountColumn',
      NetPriceColumn: 'OrderDetailsLocalization.NetPriceColumn',
    },
    Type: {
      WarrantyDraft: 'OrderTypesLocalization.WarrantyDraftOrder',
      SeasonalDraft: 'OrderTypesLocalization.SeasonalDraftOrder',
      Seasonal: 'OrderTypesLocalization.SeasonalOrder',
      Draft: 'OrderTypesLocalization.DraftOrder',
      Normal: 'OrderTypesLocalization.NormalOrder',
      WarrantyRejected: 'OrderTypesLocalization.WarrantyRejectedOrder',
      Warranty: 'OrderTypesLocalization.WarrantyOrder',
    },
    Status: {
      PartiallySent: 'OrderStatusesLocalization.PartiallySent',
      Draft: 'OrderStatusesLocalization.Draft',
      All: 'OrderStatusesLocalization.All',
      Sent: 'OrderStatusesLocalization.Sent',
      Delivered: 'OrderStatusesLocalization.Delivered',
      Seasonal: 'OrderStatusesLocalization.Seasonal',
      Invoiced: 'OrderStatusesLocalization.Invoiced',
      OrderProcessing: 'OrderStatusesLocalization.OrderProcessing',
      PartiallyInvoiced: 'OrderStatusesLocalization.PartiallyInvoiced',
      Awaiting: 'OrderStatusesLocalization.Awaiting',
      Rejected: 'OrderStatusesLocalization.Rejected',
      Expected: 'OrderStatusesLocalization.Expected',
    },
  },
  TechnicalMessage: {
    Block: {
      TechnicalMessage: 'TechnicalMessageLocalization.TechnicalMessage',
      ClearFilters: 'TechnicalMessageLocalization.ClearFilters',
      Hide: 'TechnicalMessageLocalization.Hide',
      Date: 'TechnicalMessageLocalization.Date',
      MessageType: 'TechnicalMessageLocalization.MessageType',
      Description: 'TechnicalMessageLocalization.Description',
      Attachments: 'TechnicalMessageLocalization.Attachments',
      Search: 'TechnicalMessageLocalization.Search',
      Type: 'TechnicalMessageLocalization.Type',
      Title: 'TechnicalMessageLocalization.Title',
      Text: 'TechnicalMessageLocalization.Text',
      WithAttachments: 'TechnicalMessageLocalization.WithAttachments',
      WithoutAttachments: 'TechnicalMessageLocalization.WithoutAttachments',
      All: 'TechnicalMessageLocalization.All',
      MarkAsRead: 'TechnicalMessageLocalization.MarkAsRead',
      Open: 'TechnicalMessageLocalization.Open',
      CreateNewMessage: 'TechnicalMessageLocalization.CreateNewMessage',
      MessageSuccessfullyCreated: 'TechnicalMessageLocalization.MessageSuccessfullyCreated',
      TechnicalMessageTotalInfo: 'TechnicalMessageLocalization.TechnicalMessageTotalInfo',
      TechnicalMessagePage: 'TechnicalMessageLocalization.TechnicalMessagePage',
      UploadDocuments: 'TechnicalMessageLocalization.UploadDocuments',
      Group: 'TechnicalMessageLocalization.Group',
      Send: 'TechnicalMessageLocalization.Send',
      PickAtLeastOneDealer: 'TechnicalMessageLocalization.PickAtLeastOneDealer',
      TitleCannotBeEmpty: 'TechnicalMessageLocalization.TitleCannotBeEmpty',
      TextMessageCannotBeEmpty: 'TechnicalMessageLocalization.TextMessageCannotBeEmpty',
      PasteWithFormatting: 'TechnicalMessageLocalization.PasteWithFormatting',
    },
    Status: {
      Information: 'TechnicalMessageLocalization.StatusInfo',
      Critical: 'TechnicalMessageLocalization.StatusCritical',
      Important: 'TechnicalMessageLocalization.StatusImportant',
    },
  },
  BuyersCertificate: {
    Block: {
      RequestConsent: 'BuyersCertificateLocalization.RequestConsent',
      ProductCustomModel: 'BuyersCertificateLocalization.ProductCustomModel',
      CustomerNo: 'BuyersCertificateLocalization.CustomerNo',
      Address: 'BuyersCertificateLocalization.Address',
      Email: 'BuyersCertificateLocalization.Email',
      Mobile: 'BuyersCertificateLocalization.Mobile',
      Product: 'BuyersCertificateLocalization.Product',
      Model: 'BuyersCertificateLocalization.Model',
      PostCode: 'BuyersCertificateLocalization.PostCode',
      City: 'BuyersCertificateLocalization.City',
      SalesDate: 'BuyersCertificateLocalization.SalesDate',
      RegistrationDate: 'BuyersCertificateLocalization.RegistrationDate',
      IsSerialNumberValid: 'BuyersCertificateLocalization.IsSerialNumberValid',
      Valid: 'BuyersCertificateLocalization.Valid',
      NotValid: 'BuyersCertificateLocalization.NotValid',
      RegistrationDateStart: 'Registration date start',
      RegistrationDateEnd: 'Registration date end',
      SaleDateStart: 'Sale date start',
      SaleDateEnd: 'Sale date end',
      Dealer: 'BuyersCertificateLocalization.Dealer',
      CreateNewCertificate: 'BuyersCertificateLocalization.CreateNewCertificate',
      CustomerMobile: 'BuyersCertificateLocalization.CustomerMobile',
      CustomerEmail: 'BuyersCertificateLocalization.CustomerEmail',
      CustomerPostCode: 'BuyersCertificateLocalization.CustomerPostCode',
      CustomerAddress: 'BuyersCertificateLocalization.CustomerAddress',
      CustomerCity: 'BuyersCertificateLocalization.CustomerCity',
      CustomerInformation: 'BuyersCertificateLocalization.CustomerInformation',
      ManualDelivered: 'BuyersCertificateLocalization.ManualDelivered',
      DeliveredAndTested: 'BuyersCertificateLocalization.DeliveredAndTested',
      HowItWorksInstructions: 'BuyersCertificateLocalization.HowItWorksInstructions',
      AskForConsent: 'BuyersCertificateLocalization.AskForConsent',
      BuyersCertificateCreateSuccess:
        'BuyersCertificateLocalization.BuyersCertificateCreateSuccess',
      SerialNumberInvalid: 'BuyersCertificateLocalization.SerialNumberInvalid',
      SuccessfullyUpdated: 'BuyersCertificateLocalization.SuccessfullyUpdated',
      Private: 'BuyersCertificateLocalization.Private',
      Company: 'BuyersCertificateLocalization.Company',
      ProductType: 'BuyersCertificateLocalization.ProductType',
      ProductModel: 'BuyersCertificateLocalization.ProductModel',
      Other: 'BuyersCertificateLocalization.Other',
      IsConsentGiven: 'BuyersCertificateLocalization.IsConsentGiven',
    },
    Consent: {
      Name: 'BuyersCertificateLocalization.Name',
      Address: 'BuyersCertificateLocalization.Address',
      PostCode: 'BuyersCertificateLocalization.PostCode',
      City: 'BuyersCertificateLocalization.City',
      Email: 'BuyersCertificateLocalization.Email',
      ConsentLabelCheckbox: 'BuyersCertificateLocalization.ConsentLabelCheckbox',
      ReceiveUpdatesCheckbox: 'BuyersCertificateLocalization.ReceiveUpdatesCheckbox',
      SubmitConsent: 'BuyersCertificateLocalization.SubmitConsent',
      ConsentSuccess: 'BuyersCertificateLocalization.ConsentSuccess',
      ConsentError: 'BuyersCertificateLocalization.ConsentError',
      TokenError: 'BuyersCertificateLocalization.TokenError',
    },
  },
  Warranty: {
    Status: {
      Draft: 'WarrantyLocalization.Draft',
      New: 'WarrantyLocalization.New',
      Accepted: 'WarrantyLocalization.Accepted',
      Rejected: 'WarrantyLocalization.Rejected',
      Returned: 'WarrantyLocalization.Returned',
      SentToVendor: 'WarrantyLocalization.SentToVendor',
      Credited: 'WarrantyLocalization.Credited',
      SentToVendorAndCredited: 'WarrantyLocalization.SentToVendorAndCredited',
    },
    ClaimType: {
      Complaint: 'WarrantyLocalization.Complaint',
      Goodwill: 'WarrantyLocalization.Goodwill',
      Warranty: 'WarrantyLocalization.Warranty',
    },
    Block: {
      SendToVendor: 'WarrantyLocalization.SendToVendor',
      ClaimNo: 'WarrantyLocalization.ClaimNo',
      CreditNote: 'WarrantyLocalization.CreditNote',
      InvoiceNo: 'WarrantyLocalization.InvoiceNo',
      CustomerNo: 'WarrantyLocalization.CustomerNo',
      DamageDateError: 'WarrantyLocalization.DamageDateError',
      RepairDateError: 'WarrantyLocalization.RepairDateError',
      QuantityError: 'WarrantyLocalization.QuantityError',
      RemoveDraft: 'WarrantyLocalization.RemoveDraft',
      SaveDraft: 'WarrantyLocalization.SaveDraft',
      ContinueDraft: 'WarrantyLocalization.ContinueDraft',
      AcceptError: 'WarrantyLocalization.AcceptError',
      PostCode: 'WarrantyLocalization.PostCode',
      City: 'WarrantyLocalization.City',
      ClaimType: 'WarrantyLocalization.ClaimType',
      Create: 'WarrantyLocalization.Create',
      CreateNewClaim: 'WarrantyLocalization.CreateNewClaim',
      Next: 'WarrantyLocalization.Next',
      BackToList: 'WarrantyLocalization.BackToList',
      Complete: 'WarrantyLocalization.Complete',
      FillWarrantyForm: 'WarrantyLocalization.FillWarrantyForm',
      Send: 'WarrantyLocalization.Send',
      Save: 'WarrantyLocalization.Save',
      FormSubmittedSuccessfully: 'WarrantyLocalization.FormSubmittedSuccessfully',
      Customer: 'WarrantyLocalization.Customer',
      Dealer: 'WarrantyLocalization.Dealer',
      ProductInformation: 'WarrantyLocalization.ProductInformation',
      ClearDraft: 'WarrantyLocalization.ClearDraft',
      Clear: 'WarrantyLocalization.Clear',
      FormSavedAsDraft: 'WarrantyLocalization.FormSavedAsDraft',
      ClickHere: 'WarrantyLocalization.ClickHere',
      SerialNumber: 'WarrantyLocalization.SerialNumber',
      SerialNumberIncorrect: 'WarrantyLocalization.SerialNumberIncorrect',
      SelectBrand: 'WarrantyLocalization.SelectBrand',
      Name: 'WarrantyLocalization.Name',
      Address: 'WarrantyLocalization.Address',
      ContactPerson: 'WarrantyLocalization.ContactPerson',
      Email: 'WarrantyLocalization.Email',
      SerialNo: 'WarrantyLocalization.SerialNo',
      ProductType: 'WarrantyLocalization.ProductType',
      EngineNo: 'WarrantyLocalization.EngineNo',
      UploadRecipe: 'WarrantyLocalization.UploadRecipe',
      HoursOfWork: 'WarrantyLocalization.HoursOfWork',
      SaleDate: 'WarrantyLocalization.SaleDate',
      DestinationCode: 'WarrantyLocalization.DestinationCode',
      DamageDate: 'WarrantyLocalization.DamageDate',
      RepairDate: 'WarrantyLocalization.RepairDate',
      IssueDescription: 'WarrantyLocalization.IssueDescription',
      Parts: 'WarrantyLocalization.Parts',
      NoItemsAdded: 'WarrantyLocalization.NoItemsAdded',
      TotalPrice: 'WarrantyLocalization.TotalPrice',
      ProductModel: 'WarrantyLocalization.ProductModel',
      PurchaseType: 'WarrantyLocalization.PurchaseType',
      Work: 'WarrantyLocalization.Work',
      OtherCost: 'WarrantyLocalization.OtherCost',
      DealerName: 'WarrantyLocalization.DealerName',
      CreatedDate: 'WarrantyLocalization.CreatedDate',
      CustomerName: 'WarrantyLocalization.CustomerName',
      SaleDateCapitalLetter: 'WarrantyLocalization.SaleDateCapitalLetter',
      DamageDateCapitalLetter: 'WarrantyLocalization.DamageDateCapitalLetter',
      Brand: 'WarrantyLocalization.Brand',
      Status: 'WarrantyLocalization.Status',
      Labor: 'WarrantyLocalization.Labor',
      Freight: 'WarrantyLocalization.Freight',
      Diverse: 'WarrantyLocalization.Diverse',
      Troubleshooting: 'WarrantyLocalization.Troubleshooting',
      SelectInTheList: 'WarrantyLocalization.SelectInTheList',
      PartNo: 'WarrantyLocalization.PartNo',
      CreateSuccess: 'WarrantyLocalization.CreateSuccess',
      Accept: 'WarrantyLocalization.Accept',
      Reject: 'WarrantyLocalization.Reject',
      StatusChangeError: 'WarrantyLocalization.StatusChangeError',
      StatusChanged: 'WarrantyLocalization.StatusChanged',
      SaleDateStart: 'WarrantyLocalization.SaleDateStart',
      SaleDateEnd: 'WarrantyLocalization.SaleDateEnd',
      DamageDateStart: 'WarrantyLocalization.DamageDateStart',
      DamageDateEnd: 'WarrantyLocalization.DamageDateEnd',
      RepairDateStart: 'WarrantyLocalization.RepairDateStart',
      RepairDateEnd: 'WarrantyLocalization.RepairDateEnd',
      ReportNo: 'WarrantyLocalization.ReportNo',
      Warranty: 'WarrantyLocalization.Warranty',
      Complaint: 'WarrantyLocalization.Complaint',
      Type: 'WarrantyLocalization.Type',
      Price: 'WarrantyLocalization.Price',
      Quantity: 'WarrantyLocalization.Quantity',
      SelectServiceType: 'WarrantyLocalization.SelectServiceType',
      PartCannotBeAdded: 'WarrantyLocalization.PartCannotBeAdded',
      ReturnToDealer: 'WarrantyLocalization.ReturnToDealer',
      WarrantyStatusUpdateError: 'WarrantyLocalization.WarrantyStatusUpdateError',
      WarrantyStatusUpdated: 'WarrantyLocalization.WarrantyStatusUpdated',
      Id: 'WarrantyLocalization.Id',
      Compliant: 'WarrantyLocalization.Compliant',
      Goodwill: 'WarrantyLocalization.Goodwill',
      Private: 'WarrantyLocalization.Private',
      External: 'WarrantyLocalization.External',
      Internal: 'WarrantyLocalization.Internal',
      Comment: 'WarrantyLocalization.Comment',
      Description: 'WarrantyLocalization.Description',
      Others: 'WarrantyLocalization.Others',
      WarrantyClaimCreateError: 'WarrantyLocalization.WarrantyClaimCreateError',
      SymptomCode: 'WarrantyLocalization.SymptomCode',
      DefectCode: 'WarrantyLocalization.DefectCode',
      IssueDescriptionError: 'WarrantyLocalization.IssueDescriptionError',
      PartNoError: 'WarrantyLocalization.PartNoError',
      PossibleCauseOfError: 'WarrantyLocalization.PossibleCauseOfError',
      MoreInformation: 'WarrantyLocalization.MoreInformation',
      BrandSerialNumberSelection: 'WarrantyLocalization.BrandSerialNumberSelection',
      WarrantyClaimForm: 'WarrantyLocalization.WarrantyClaimForm',
      QuantityErrorMax: 'WarrantyLocalization.QuantityErrorMax',
      FutureDateError: 'WarrantyLocalization.FutureDateError',
      SerialNumberIncorrectError: 'WarrantyLocalization.SerialNumberIncorrectError',
      Company: 'WarrantyLocalization.Company',
      PartNotValid: 'WarrantyLocalization.PartNotValid',
      PartNumber: 'WarrantyLocalization.PartNumber',
      SerialNumberClaimed: 'WarrantyLocalization.SerialNumberClaimed',
      PartQuantityError: 'WarrantyLocalization.PartQuantityError',
      SpecifyMoreInformation: 'WarrantyLocalization.SpecifyMoreInformation',
      ReviewedBy: 'WarrantyLocalization.ReviewedBy',
      WarrantyDetails: 'WarrantyLocalization.WarrantyDetails',
    },
  },
};
